import { apiClient } from '@/shared/api';
import { API_ENDPOINTS } from '@/config';
import { buildCommonHeaders } from '@/shared/http/commonHeaders';
import type { Tag, CreateTagRequest, UpdateTagRequest } from '@/features/card/types/card.types';

export const tagManagerService = {
    async createTag(payload: CreateTagRequest, customerUuid: string, accountUuid: string): Promise<{ data: Tag, response: string }> {
        const newHeaders = buildCommonHeaders({ withLocation: true });
        return apiClient.post(API_ENDPOINTS.tags.create(customerUuid, accountUuid), { data: { data: payload } }, { headers: { ...newHeaders } });
    },

    async updateTag(payload: UpdateTagRequest, customerUuid: string, accountUuid: string, tagName: string): Promise<{ data: Tag, response: string }> {
        const newHeaders = buildCommonHeaders({ withLocation: true });
        return apiClient.post(API_ENDPOINTS.tags.update(customerUuid, accountUuid, tagName), { data: { data: payload } }, { headers: { ...newHeaders } });
    },

    async deleteTag(customerUuid: string, accountUuid: string, tag_name: string): Promise<{ response: string }> {
        const newHeaders = buildCommonHeaders({ withLocation: true });
        return apiClient.post(API_ENDPOINTS.tags.delete(customerUuid, accountUuid, tag_name), { headers: { ...newHeaders } });
    }
};
